import { render, staticRenderFns } from "./IconMicrosoftLoginLogo.vue?vue&type=template&id=38f4b91c&scoped=true"
import script from "./IconMicrosoftLoginLogo.vue?vue&type=script&lang=js"
export * from "./IconMicrosoftLoginLogo.vue?vue&type=script&lang=js"
import style0 from "./IconMicrosoftLoginLogo.vue?vue&type=style&index=0&id=38f4b91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4b91c",
  null
  
)

export default component.exports